import React from "react";
import Title from "../layouts/Title";
import {
  projectOne,
  projectTwo,
  projectThree,
  projectCar,
  projectBoss,
  projectCam,
} from "../../assets/index";
import ProjectsCard from "./ProjectsCard";

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title title="Bringing Ideas to Life with Code." des="My Projects" />
      </div>
      <div
        className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14"
        data-aos="fade-up"
        data-aos-anchor-placement="top-bottom"
      >
        <ProjectsCard
          title="Car Rental Reservation"
          des="A car rental platform that allows users to browse available cars, manages bookings, and makes secure payments. The
system includes features for both customers and administrators, with a focus on responsiveness and security."
          tech="React.js, Tailwind CSS, Node.js, Express.js, MongoDB, Mongoose, React Hook Form, Ant Design, Redux, JWT,
Moment.js, Nodemailer"
          src={projectCar}
          git={"https://github.com/JiJetu/Car-Rental-Reservation-System-Client"}
          git2={
            "https://github.com/JiJetu/Car-Rental-Reservation-System-Backend"
          }
          liv={"https://car-rental-reservation-system-client-six.vercel.app/"}
        />
        <ProjectsCard
          title="Bistro Boss"
          des="A comprehensive web application designed for seamless restaurant operations, catering to both customers and administrators."
          tech="React with Tailwind CSS (Frontend), Express.js (Backend), MongoDB (Database), Firebase Auth (Authentication), Stripe (Payment Gateway), Recharts (Data Visualization)"
          src={projectBoss}
          git={"https://github.com/JiJetu/Bistro-Boss"}
          liv={"https://bistro-boss-e954b.web.app/"}
        />
        <ProjectsCard
          title="Campers Shop"
          des="The Campers Shop Client is an e-commerce platform. This project is designed to provide a seamless user experience for browsing and purchasing camping gear and related products."
          tech="React.js, Tailwind CSS, Node.js, Express.js, MongoDB, Mongoose, React Hook Form, Ant Design, Redux, JWT"
          src={projectCam}
          git={"https://github.com/JiJetu/Wilderness-Wonders-Client"}
          git2={"https://github.com/JiJetu/Wilderness-Wonders-Server"}
          liv={"https://campers-shop-client-beta.vercel.app/"}
        />
        <ProjectsCard
          title="WiredInnovators"
          des=" Reliable online marketplace showcasing a wide array of products from various brands as a Brand Shop Retail and E-Commerce."
          tech="Html, Css, JavaScript, React, Firebase, Mongodb, NodeJs"
          src={projectOne}
          git={"https://github.com/JiJetu/Brand-Shop-Client"}
          git2={"https://github.com/JiJetu/Brand-Shop-server"}
          liv={"https://assignment-10-4908f.web.app/"}
        />
        <ProjectsCard
          title="Donation Campaign"
          des="Discover a purposeful donation website offering four impactful categories, empowering users to contribute seamlessly to causes they care
          about."
          tech="Html, Css, JavaScript, React"
          src={projectTwo}
          git={"https://github.com/JiJetu/Donation-Campaign"}
          liv={"https://spontaneous-bombolone-eb5333.netlify.app/"}
        />
        <ProjectsCard
          title="Game On Galaxy"
          des="Experience my React-powered gaming hub, fortified with seamless Firebase authentication. Instantly access exclusive gaming events with Google login. Witness innovation in action."
          tech="Html, Css, JavaScript, React, Firebase"
          src={projectThree}
          git={"https://github.com/JiJetu/GameOn-Galaxy-Auth"}
          liv={"https://assignment-9-3b0b4.web.app/"}
        />
      </div>
    </section>
  );
};

export default Projects;
